export default [
  {
    header: 'Accounting',
    icon: 'DollarSignIcon',    
    children: [
      {
        title: 'เบิกค่าเดินทาง',
        route: 'accounting', 
        icon: 'ClipboardIcon',
        permissionCode:'AC001',
      },
      {
        title: ' Expenses report by employee',
        route: 'accounting-admin', 
        icon: 'PackageIcon',
        permissionCode:'AC002',
      }
    ]            
  },
]


